export default {
  name: "table-no-item",
  props: {
    data: "",
    message: "",
  },
  data() {
    return {};
  },

  components: {},
  create() {},

  methods: {},
};
